import CommonService from './common.service'

class TaxService extends CommonService {
  async all() {
    return await this.get('/tax-rates')
  }
}

export const taxService = new TaxService()
